import {
    createLazyComponent,
    LazyAction,
    type LazyComponent,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import type { AccountLinkProps } from './components/AccountLinkSection';
import type * as lazyIndex from './lazyIndex';
import { getAccountLinkStore } from './store/store';
import { onCoprincipalBootStateChanged } from 'owa-account-source-list-store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaCloudCacheLink" */ './lazyIndex'),
    { name: 'OwaCloudCacheLink' }
);

export const AccountLinkSection: LazyComponent<AccountLinkProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.AccountLinkSection);

export const LinkWithEasidDialogLightning: LazyComponent<unknown, unknown, void> =
    createLazyComponent(lazyModule, m => m.LinkWithEasidDialogLightning, undefined, undefined, {
        onlyImportIf: () => !!getAccountLinkStore().accountToLink,
    });

export const lazyInitializeCloudCacheLinkStore: LazyAction<
    typeof lazyIndex.initializeCloudCacheLinkStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeCloudCacheLinkStore);

export const lazyInitializeCloudCacheLinkStoreAndDialog: LazyAction<
    typeof lazyIndex.initializeCloudCacheLinkStoreAndDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeCloudCacheLinkStoreAndDialog);

registerLazyOrchestrator(
    onCoprincipalBootStateChanged,
    lazyModule,
    m => m.onCoprincipalAccountAddedOrchestrator
);
